<template>
    <i :class="[iconClasses.trim(), colorClasses]" :style="componentStyle"></i>
</template>

<script>
    export default {
        name: 'IconRenderer',
        props: ['component', 'layout'],
        computed: {
            iconStyle() {
                return this.component.value.style
            },
            iconValue() {
                return 'fa-' + this.component.value.icon
            },
            iconSize() {
                return 'fa-' + this.component.style.size
            },
            iconClasses() {
                return this.iconStyle + ' ' + this.iconValue + ' ' + this.iconSize
            },
            componentStyle() {
                return {
                    ...this.colorStyle
                }
            },
            colorClasses() {
                if(this.layout.theme_id) {
                    return ''
                }

                if(this.component.style && this.component.style.color && this.component.style.color !== 'custom' && this.component.style.color.indexOf('#') !== 0 ) {
                    return `text-${this.component.style.color}`
                }

                return ''
            },

            colorStyle() {
                return this.isCustomColor ? { color: this.component.style.color } : {}
            },

            isCustomColor() {
                return this.component.style && this.component.style.color && this.component.style.color.indexOf('#') === 0
            }
        }
    }
</script>

<style>

</style>